import { BootstrapOptions, Module } from 'owa-bootstrap';
import { getBootstrapOptions, registerBootstrapOptions } from 'owa-app-module';
import updateModule from 'owa-app-module/lib/actions/updateModule';
import getCurrentModule from 'owa-app-module/lib/selectors/getCurrentModule';
import { getWindowTitle } from 'owa-bootstrap/lib/initialization/getWindowTitle';
import initializeWindowTitle from 'owa-shared-bootstrap/lib/initializeWindowTitle';
import { OwaWorkload, setOwaWorkload } from 'owa-workloads';
import { registerFontSubsets } from 'owa-icons';
import { getPackageBaseUrl } from 'owa-config';
import { preloadStrategies } from 'owa-shared-bootstrap/lib/preloadStrategies';
import { moduleToConfigMap } from './configRegistry';
import { orchestrator } from 'satcheljs';
import { onModuleClick, isModuleSwitchEnabled } from 'owa-left-rail-utils';
import { switchVdirForRouter } from 'owa-router';
import { setApp } from 'owa-config/lib/bootstrapOptions';
import { updateServiceConfig } from 'owa-service/lib/config';
import { getBposNavBarDataAsync } from 'owa-bpos-store';

let isRunning = false;

orchestrator(onModuleClick, actionMessage => {
    const newModule = actionMessage.module;
    if (
        getCurrentModule() != newModule &&
        isModuleSwitchEnabled(actionMessage.currentlySelectedModule, newModule) &&
        !isRunning
    ) {
        isRunning = true;
        changeModuleInternal(newModule).then(resetIsRunning, resetIsRunning);
    }
});

function resetIsRunning() {
    isRunning = false;
}

async function changeModuleInternal(newModule: Module) {
    setApp(newModule);
    updateServiceConfig({ appName: newModule });
    let options: BootstrapOptions | undefined = getBootstrapOptions(newModule);
    if (options) {
        await switchVdirForRouter(
            options.vdir || newModule,
            options.registerRoutes!,
            options.routerOptions!
        );
    } else {
        const lazyConfig = moduleToConfigMap[newModule]!;
        options = await lazyConfig.options.importAndExecute(
            Promise.resolve(undefined),
            lazyConfig.strategies
        )!;
        registerBootstrapOptions(options!);
        await switchVdirForRouter(
            options!.vdir || newModule,
            options!.registerRoutes!,
            options!.routerOptions!
        );
        const promises = preloadStrategies(options!.strategies)
            .filter(p => p)
            .map(p => p.promise);
        const statePromise = options!.initializeState();
        if (statePromise) {
            promises.push(statePromise);
        }

        promises.push(getBposNavBarDataAsync());
        registerFontSubsets(getPackageBaseUrl(), options!.iconFonts);
        const postLazyAction = options!.postLazyAction;
        if (postLazyAction) {
            postLazyAction.importAndExecute.apply(postLazyAction, options!.postLazyArgs || []);
        }
        await Promise.all(promises);
    }

    initializeWindowTitle(() => getWindowTitle(options!.getModuleName));
    setOwaWorkload(options!.workload || OwaWorkload.None);
    updateModule(newModule);
}
